
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import { TagesjournalOptions } from '@/store/statistik';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders']),
        },
        methods: {
            ...mapActions('statistik', ['printTagesjournal', 'exportTagesjournal']),
        },
    })
    export default class TagesjournalDialog extends Vue {
        @Prop() public visible!: boolean;

        public printTagesjournal!: (payload: { options: TagesjournalOptions }) => void;
        public exportTagesjournal!: (payload: { options: TagesjournalOptions }) => void;

        public zeitpunktMenu = false;

        public options: TagesjournalOptions = {
            zeitpunkt: moment().format('YYYY-MM-DD'),
            nachUhrzeit: false,
        };

        public get canPrint(): boolean {
            return !!this.options.zeitpunkt;
        }

        public get maxZeitpunkt(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get zeitpunktLabel(): string {
            if (this.options.zeitpunkt.length) {
                const [year, month, day] = this.options.zeitpunkt.split('-');
                return `${day}.${month}.${year}`;
            }
            return '';
        }

        public closeMenu(): void {
            this.zeitpunktMenu = false;
        }

        public onClickPrint(): void {
            const options = {
                ...this.options,
            };

            this.printTagesjournal({ options });
        }

        public onClickExport(): void {
            const options = {
                ...this.options,
            };

            this.exportTagesjournal({ options });
        }
    }
